
module.exports = {
    googleID: "",
};